import React, { useContext, useState, useEffect } from "react";
import { AuthContext } from "../../context/AuthContext";
import PreviewLink from "../links/previewLink/PreviewLink";
import DownloadLink from "../links/downloadLink/DownloadLink";
import ExternalLink from "../links/externalLink/ExternalLink";
import "./Sheet.css";
import file from "../../assets/file.png";
import SpecsheetButtonWhite from "../button/specsheetButtonWhite/SpecsheetButtonWhite";
import SpecsheetButtonBlue from "../button/specsheetButtonBlue/SpecsheetButtonBlue";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import lastUpdatedDate from "../../helpers/lastUpdatedDate";
import desktopIcon from "../../assets/desktopIcon.svg";
import mobileIcon from "../../assets/mobileIcon.svg";
import tabletIcon from "../../assets/tabletIcon.svg";
import inappIcon from "../../assets/inappIcon.svg";
import desktopMobileIcon from "../../assets/desktopMobileIcon.svg";
import desktopTabletIcon from "../../assets/desktopTabletIcon.svg";
import desktopMobileTabletIcon from "../../assets/desktopMobileTabletIcon.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, Scrollbar } from "swiper";
import "swiper/css";
import "swiper/swiper-bundle.css";
import { TrackGoogleAnalyticsEvent } from "../../helpers/InitializeGoogleAnalytics";
import createGoogleAnalyticsTemplateName from "../../helpers/createGoogleAnalyticsTemplateName";
import FunctionalButton from "../button/FunctionalButton";
import PublisherIcon from "../publisherIcon/PublisherIcon";

SwiperCore.use([Navigation, Scrollbar]);

const Sheet = ({
  lastUpdate,
  creatives,
  name,
  additionalTemplateInformation,
  previewLinks,
  downloadLinks,
  previewPages,
  toggleShowModifyForm,
}) => {
  const { user } = useContext(AuthContext);
  const [sidebarDownloads, setSidebarDownloads] = useState(false);
  const [sidebarPreviews, setSidebarPreviews] = useState(false);
  const [sidebarCreativeInformation, setSidebarCreativeInformation] =
    useState(false);
  const [sidebarPositionDetails, setSidebarPositionDetails] = useState(false);
  const [overlayActive, setOverlayActive] = useState(false);

  const [imageIndex, setImageIndex] = useState(0);
  const [deviceImage, setDeviceImage] = useState("");
  const [logo, setLogo] = useState("logo0");
  const [numberOfTiles, setNumberOfTiles] = useState(0);
  const [creativeNumber, setCreativeNumber] = useState(0);
  const [positionNumber, setPositionNumber] = useState(0);
  const [positionListNumber, setPositionListNumber] = useState(0);
  const [logoIds, setLogoIds] = useState([]);
  const [creativeIcons, setCreativeIcons] = useState([]);

  const [scrollbarDragSize, setScrollbarDragSize] = useState(200);

  useEffect(() => {
    function checkWidth() {
      calculateNumberOfTilesAndScrollbarWidth();
      window.addEventListener("resize", handleResize);
    }

    checkWidth();
  }, []);

  useEffect(() => {
    function setBorder() {
      setDeviceImage(creatives[0].creative);
    }
    if (creatives) {
      setBorder();
    }
  }, [creatives]);

  // This function will change the number of tiles on resizing after the page has loaded.
  function handleResize() {
    calculateNumberOfTilesAndScrollbarWidth();
  }

  // this function will change the number of tiles  (logos and device icons) on display according to the size of the window. This function will also be activated on resizing the window
  function calculateNumberOfTilesAndScrollbarWidth() {
    const element = document.getElementsByClassName(
      "specification-container"
    )[0];
    const width = element.getBoundingClientRect().width;
    if (width > 891) {
      setNumberOfTiles(6);
      setScrollbarDragSize(600);
    }
    if (width > 770 && width < 890) {
      setNumberOfTiles(5);
      setScrollbarDragSize(600);
    }
    if (width > 681 && width < 769) {
      setNumberOfTiles(4);
      setScrollbarDragSize(600);
    }
    if (width > 439 && width < 680) {
      setNumberOfTiles(3);
      setScrollbarDragSize(400);
    }
    if (width > 1 && width < 438) {
      setNumberOfTiles(2.2);
      setScrollbarDragSize(200);
    }
  }

  // This function will set all sidebars and the overlay back to false (not visible).
  const resetOverlay = () => {
    setOverlayActive(false);
    setSidebarPreviews(false);
    setSidebarDownloads(false);
    setSidebarCreativeInformation(false);
    setSidebarPositionDetails(false);
  };

  // This function will expand the sidebar for downloads and the google analytics tracking
  const showSidebarDownloads = () => {
    if (!sidebarDownloads) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Down: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setSidebarDownloads(!sidebarDownloads);
    setOverlayActive(!overlayActive);
    if (sidebarPreviews) {
      setSidebarPreviews(false);
    } else {
    }
  };

  // This function will expand the sidebar for previews and the google analytics tracking
  const showSidebarPreviews = () => {
    if (!sidebarPreviews) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Prev: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setOverlayActive(!overlayActive);
    setSidebarPreviews(!sidebarPreviews);
    if (sidebarDownloads) {
      setSidebarDownloads(false);
    }
  };

  // This function will expand the sidebar for positions specifications and the google analytics tracking
  const showSideBarPositionDetails = () => {
    if (!sidebarPositionDetails) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Spec: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setOverlayActive(!overlayActive);
    setSidebarPositionDetails(!sidebarPositionDetails);
  };

  // This function will expand the sidebar for specsheetsInformation and the google analytics tracking
  const showSidebarGenericSpecsheetInformation = () => {
    if (!sidebarCreativeInformation) {
      TrackGoogleAnalyticsEvent(
        "click",
        `CTA Gene: ${createGoogleAnalyticsTemplateName(name)}`,
        "click"
      );
    }

    setOverlayActive(!overlayActive);
    setSidebarCreativeInformation(!sidebarCreativeInformation);
  };

  // On click scroll to general template information
  const scrollToGeneralTemplateInformation = () => {
    scrollToTarget("general-template-information-container");
  };

  // On click scroll to examples
  const scrollToExamples = () => {
    scrollToTarget("template-examples");
  };

  // On click scroll to specifications
  const scrollToSpecifications = () => {
    scrollToTarget("specification-container");
  };

  // set the scroll target
  function scrollToTarget(target) {
    var elem = document.getElementsByClassName(target)[0];
    elem.scrollIntoView({ behavior: "smooth" });
  }

  // Insert the right styling for the displayFields
  function displayFields(subject, text, type, url) {
    if (type === "text" && subject != "") {
      return (
        <div className="item">
          <p className="item-title">{subject}:</p>

          <p>{text}</p>
        </div>
      );
    }
    if (type === "text" && subject === "") {
      return (
        <div className="item">
          <p>{text}</p>
        </div>
      );
    }

    if (type === "url") {
      return (
        <ExternalLink key={url} link={url}>
          {text}
        </ExternalLink>
      );
    }
  }

  // If there is a download option show it and otherwise show a no download text.
  function showDownload(downloadLinks) {
    if (downloadLinks[0].type === "") {
      return (
        <div className="download-links-container">
          <div className="container-title-download">
            <p className="download-template-title">DOWNLOAD TEMPLATE</p>
            <FontAwesomeIcon
              className="download-icon"
              icon={faXmark}
              onClick={showSidebarDownloads}
            />
          </div>
          <p> No download option available</p>
        </div>
      );
    } else {
      return (
        <div className="download-links-container">
          <div className="download-section">
            <div className="container-title-download">
              <p className="download-template-title">DOWNLOAD TEMPLATE</p>
              <FontAwesomeIcon
                className="download-icon"
                icon={faXmark}
                onClick={showSidebarDownloads}
              />
            </div>
            <div className="download-introduction-container">
              <p>Download this template to your device and start creating</p>
            </div>

            <p className="template-name">{name}</p>
            {downloadLinks?.map((downloadLink) => {
              const { type, link } = downloadLink;

              return (
                <div key={link}>
                  <DownloadLink type={type} link={link} name={name} />
                </div>
              );
            })}
          </div>
          <div className="documentation-link-container">
            <p>
              For more information how to work with the previewer please visit
              our{" "}
              <span>
                <ExternalLink
                  link={
                    "https://support.weborama.nl/hc/en-us/sections/6818722316188-Working-with-the-previewer"
                  }
                >
                  previewer documentation.
                </ExternalLink>
              </span>
            </p>
          </div>
        </div>
      );
    }
  }

  // This will activate (and deactivate if needed) the border of the logo icon and set the right image to be displayed
  function activateLogo(e, i, targetLogo) {
    if (logo != "") {
      document.getElementsByClassName(logo)[0].classList.remove("border");
      document.getElementsByClassName(logo)[1].classList.remove("border");
    }
    const element = e.target.className;
    document.getElementsByClassName(element)[0].classList.add("border");
    document.getElementsByClassName(element)[1].classList.add("border");

    setLogo(targetLogo);
    setImageIndex(i);
  }

  // This will activate (and deactivate if needed) the border of the device icon
  function activateDeviceType(e, creativeName, i) {
    if (deviceImage != "") {
      document
        .getElementsByClassName(deviceImage)[0]
        .classList.remove("border");
    }

    e.target.classList.add("border");
    setDeviceImage(creativeName);
    setCreativeNumber(i);
    setPositionNumber(0);
    setPositionListNumber(0);
    setImageIndex(0);
  }

  // When the creative number changes we select the id of the publisher icons and push them into an array.
  useEffect(() => {
    createDeviceImagesList();
    createLogoIdList();
  }, [creativeNumber]);

  function createDeviceImagesList() {
    const array = [];
    for (let i = 0; i < creatives.length; i++) {
      const device = {
        iconType: creatives[i].creativeIcon,
        creativeName: creatives[i].creative,
      };
      array.push(device);
    }
    setCreativeIcons(array);
  }

  function createLogoIdList() {
    const array = [];
    for (let i = 0; i < creatives[creativeNumber].images.length; i++) {
      array.push(creatives[creativeNumber].images[i].website);
    }
    setLogoIds(array);
  }

  // When Icons are saved from the backend this function will display the right logos according to the websites of the preview image (inside swiper). We also set the border on click.
  function displayLogos(id, index) {
    const logos = [];

    let border = "";
    if (index === 0) {
      border = "border";
    } else {
      border = "";
    }
    logos.push(
      <SwiperSlide
        key={`logo-slide-${index}}`}
        tag="li"
        style={{ listStyle: "none" }}
      >
        <PublisherIcon
          logoId={id}
          index={index}
          border={border}
          handleClick={(e) => {
            activateLogo(e, index, `logo${index}`);
          }}
        />
      </SwiperSlide>
    );
    return logos;
  }

  // This function will display the right icons according to the creative type (inside swiper)
  function displayIcons(creative, index) {
    const { iconType, creativeName } = creative;
    const icons = [];
    let border = "";
    let icon;

    if (iconType.toLowerCase() === "desktop") {
      icon = desktopIcon;
    } else if (iconType.toLowerCase() === "mobile") {
      icon = mobileIcon;
    } else if (iconType.toLowerCase() === "tablet") {
      icon = tabletIcon;
    } else if (iconType.toLowerCase() === "inapp") {
      icon = inappIcon;
    } else if (iconType.toLowerCase() === "desktopmobiletablet") {
      icon = desktopMobileTabletIcon;
    } else if (iconType.toLowerCase() === "desktopmobile") {
      icon = desktopMobileIcon;
    } else if (iconType.toLowerCase() === "desktoptablet") {
      icon = desktopTabletIcon;
    } else {
      icon = desktopIcon;
    }
    if (index === 0) {
      border = "border";
    } else {
      border = "";
    }

    icons.push(
      <SwiperSlide
        key={`icon-slide-${index}}`}
        tag="li"
        style={{ listStyle: "none" }}
      >
        <img
          className={`device-website-icon ${creativeName} ${border}`}
          src={icon}
          alt={`${icon} icon`}
          key={index}
          onClick={(e) => activateDeviceType(e, creativeName, index)}
        />
      </SwiperSlide>
    );

    return icons;
  }

  // This function will display the template example button only if there is an image
  function displayTemplateExamplesButton(images) {
    if (images[0] !== undefined) {
      if (images[0].url !== "" || images[0].website !== "") {
        return (
          <SpecsheetButtonWhite type="button" handleClick={scrollToExamples}>
            Template examples
          </SpecsheetButtonWhite>
        );
      }
    }
  }

  // This function will only show the image container when there is an image
  function displayImageContainer(images) {
    if (images[0] !== undefined) {
      if (images[0].url !== "" || images[0].website !== "") {
        return (
          <div className="template-examples-container">
            <p className="template-examples template-examples-title">
              TEMPLATE EXAMPLES
            </p>

            <div className="container">
              <div className="logo-container-horizontal">
                <Swiper
                  modules={[Navigation]}
                  direction="horizontal"
                  className="logo-swiper-horizontal"
                  spaceBetween={10}
                  slidesPerView={numberOfTiles}
                  navigation
                >
                  {logoIds?.map((id, index) => {
                    return displayLogos(id, index);
                  })}
                </Swiper>
              </div>
              <div className="logo-container-vertical">
                <Swiper
                  modules={[Navigation]}
                  className="logo-swiper-vertical"
                  spaceBetween={7}
                  direction="vertical"
                  slidesPerView={3}
                  navigation
                >
                  {logoIds?.map((id, index) => {
                    return displayLogos(id, index);
                  })}
                </Swiper>
              </div>
              <div className="image-container">
                <img src={images[imageIndex].url} alt="example"></img>
              </div>
            </div>
          </div>
        );
      }
    }
  }

  // This will display all the positions and underline the current on display.
  function displayPositions(positions) {
    const positionsArray = [];
    let border = "";
    let color = "";
    for (let i = 0; i < positions.length; i++) {
      if (i === positionNumber) {
        border = "position-underline";
        color = "position-color";
      } else {
        border = "";
        color = "";
      }

      positionsArray.push(
        <div key={i} className={` position-wrapper ${border}`}>
          <p
            className={`position position ${positions[i].position} ${color}`}
            onClick={() => {
              setPositionNumber(i);
              setPositionListNumber(0);
            }}
          >
            {`${positions[i].position} position`}
          </p>
        </div>
      );
    }

    return positionsArray;
  }

  // This function will show the specification buttons (doubles are filtered out with the checkArray) buttonArray contains react nested objects so therefore an extra checkingArray
  function displayPositionInformationButtons(currentCreative) {
    const buttonArray = [];
    const checkArray = [];
    for (let i = 0; i < currentCreative.positionsList.length; i++) {
      if (!checkArray.includes(currentCreative.positionsList[i].title)) {
        checkArray.push(currentCreative.positionsList[i].title);
        buttonArray.push(
          <SpecsheetButtonWhite
            type="button"
            handleClick={() => {
              setPositionListNumber(i);
              showSideBarPositionDetails();
              setOverlayActive(!overlayActive);
            }}
            key={`${currentCreative.positionsList[i].title}`}
          >
            {`${currentCreative.positionsList[i].title} info`}
          </SpecsheetButtonWhite>
        );
      }
    }

    return buttonArray;
  }

  function displayModificationForm() {
    toggleShowModifyForm(true);
  }

  return (
    <div className="sheet-outside-container">
      {user?.role === "admin" && (
        <section className="modify-button-section">
          <FunctionalButton type="button" handleClick={displayModificationForm}>
            Modify specsheet
          </FunctionalButton>
        </section>
      )}
      <div className="sheet-container">
        <div className="sheet-container-top">
          <div className="top-container">
            <div className="extra-container">
              <div className="top-inner-container">
                <div className="inner-divider-block">
                  <div className="vertical-divider"></div>
                  <p className="horizontal-divider"></p>
                  <p className="title-specsheet divider">{name}</p>

                  <p className="horizontal-divider"></p>
                  <p className="specification-sheet divider">
                    SPECIFICATION SHEET
                  </p>
                  <p className="horizontal-divider empty-space"></p>
                  <p className="horizontal-divider"></p>
                  <p className="divider">
                    <span>Last update</span>
                    <span className="divider">
                      {lastUpdatedDate(lastUpdate)}
                    </span>
                  </p>

                  <p className="horizontal-divider"></p>
                  <p className="divider">
                    <span>Get support</span>

                    <span
                      className="divider mail"
                      onClick={() =>
                        (window.location = "mailto:support@weborama.nl")
                      }
                    >
                      support@weborama.nl
                    </span>
                  </p>
                  <p className="horizontal-divider"></p>
                </div>
              </div>

              <div className="preview-download-container">
                <SpecsheetButtonBlue
                  type="button"
                  handleClick={showSidebarDownloads}
                >
                  DOWNLOAD TEMPLATE
                </SpecsheetButtonBlue>

                <SpecsheetButtonWhite
                  type="button"
                  handleClick={showSidebarPreviews}
                >
                  PREVIEW TEMPLATE
                </SpecsheetButtonWhite>
              </div>
            </div>
          </div>
          <div className="preview-download-container-mobile">
            <div className="top-container">
              <div className="extra-container">
                <div className="top-inner-container">
                  <div className="inner-divider-block">
                    <div className="preview-download-inner-container-mobile">
                      <p className="horizontal-divider"></p>

                      <div className="first-button-mobile">
                        <SpecsheetButtonBlue
                          type="button"
                          handleClick={showSidebarDownloads}
                        >
                          DOWNLOAD TEMPLATE
                        </SpecsheetButtonBlue>
                      </div>

                      <p className="horizontal-divider"></p>
                      <p className="horizontal-divider"></p>

                      <div className="second-button-mobile">
                        <SpecsheetButtonWhite
                          type="button"
                          handleClick={showSidebarPreviews}
                        >
                          PREVIEW TEMPLATE
                        </SpecsheetButtonWhite>
                      </div>
                      <p className="horizontal-divider"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            sidebarPreviews ? "preview-slider__active" : "preview-slider"
          }
        >
          <div className="preview-links-container">
            <div className="container-title-download">
              <p className="preview-template-title">PREVIEW TEMPLATE</p>
              <FontAwesomeIcon
                className="download-icon"
                icon={faXmark}
                onClick={showSidebarPreviews}
              />
            </div>

            <div className="preview-container">
              <div className="preview-introduction-container">
                <p>
                  Scan QR code or click on the link below to preview the
                  template
                </p>
              </div>

              <p className="template-name">{name}</p>
              <div className="template-tiles-container">
                {previewLinks?.map((preview) => {
                  const { type, link, qr } = preview;

                  return (
                    <div className="preview-link-wrapper" key={type}>
                      <PreviewLink
                        type={type}
                        link={link}
                        qr={qr}
                        name={name}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            sidebarDownloads ? "download-slider__active" : "download-slider"
          }
        >
          {showDownload(downloadLinks)}
        </div>

        <div className="quicklinks-container">
          <p>Quicklinks:</p>

          <div className="quicklinks-inner-container">
            <SpecsheetButtonWhite
              type="button"
              handleClick={scrollToSpecifications}
            >
              Specifications
            </SpecsheetButtonWhite>
            {displayTemplateExamplesButton(creatives[creativeNumber].images)}
            <SpecsheetButtonWhite
              type="button"
              handleClick={scrollToGeneralTemplateInformation}
            >
              General template information
            </SpecsheetButtonWhite>
          </div>
        </div>

        <div className="specification-container">
          <p className="specification-title">SPECIFICATIONS</p>

          {additionalTemplateInformation && (
            <div className="additional-template-info">
              {additionalTemplateInformation}
            </div>
          )}
          <div className="icon-container">
            <div className="icon-container-horizontal">
              {creatives && (
                <div className="swiper-wrapper-with-scrollbar">
                  <Swiper
                    modules={[Navigation, Scrollbar]}
                    direction="horizontal"
                    className="icon-swiper-horizontal"
                    spaceBetween={10}
                    slidesPerView={numberOfTiles}
                    scrollbar={{
                      draggable: true,
                      el: ".swiper-scrollbar",
                      clickable: true,
                      dragSize: scrollbarDragSize,
                    }}
                    navigation
                  >
                    {creativeIcons?.map((creative, index) => {
                      return displayIcons(creative, index);
                    })}
                    <div className="swiper-scrollbar"></div>
                  </Swiper>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="creative-container">
          {creatives && (
            <div className="creative">
              <div className="creative-top-container">
                <div className="creative-name-container">
                  <h3>{`${creatives[
                    creativeNumber
                  ].creative.toUpperCase()} CREATIVE`}</h3>
                </div>
              </div>
              <div className="container-all-positions">
                <div className="position-container">
                  <div className="position-top-container">
                    <div className="position-name-container">
                      {displayPositions(creatives[creativeNumber].adPositions)}
                    </div>
                  </div>

                  {creatives[creativeNumber].adPositions[positionNumber]
                    ?.positionsList[0].type === "mediaFile" ? (
                    <div className="outer-media-container">
                      <div className="media-container">
                        <p className="position-title">Media file</p>

                        {creatives[creativeNumber].adPositions[
                          positionNumber
                        ]?.positionsList.map((position) => {
                          if (position.type === "mediaFile") {
                            return (
                              <div key={position.htmlName}>
                                <div className="file-container">
                                  <p className="title-position">
                                    {position.title}
                                  </p>
                                  <img
                                    className="file"
                                    src={file}
                                    alt="file icon"
                                  />
                                  <p>{position.htmlName}</p>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </div>
                  ) : (
                    <div className="outer-fixed-layer-container">
                      <div className="fixed-container">
                        <p className="position-title">Fixed</p>

                        {creatives[creativeNumber].adPositions[
                          positionNumber
                        ]?.positionsList.map((position) => {
                          if (position.type === "fixedPosition") {
                            return (
                              <div key={position.htmlName}>
                                <div className="file-container">
                                  <p className="title-position">
                                    {position.title}
                                  </p>
                                  <img
                                    className="file"
                                    src={file}
                                    alt="file icon"
                                  />
                                  <p>{position.htmlName}</p>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>

                      <div className="layer-container">
                        <p className="position-title">Layer</p>
                        {creatives[creativeNumber].adPositions[
                          positionNumber
                        ].positionsList.map((position) => {
                          if (position.type === "layerPosition") {
                            return (
                              <div key={position.htmlName}>
                                <div className="file-container">
                                  <p className="title-position">
                                    {position.title}
                                  </p>
                                  <img
                                    className="file"
                                    src={file}
                                    alt="file icon"
                                  />
                                  <p>{position.htmlName}</p>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    </div>
                  )}
                  <p className="position-title">Specifications</p>
                  <div className="position-button-container">
                    {displayPositionInformationButtons(
                      creatives[creativeNumber].adPositions[positionNumber]
                    )}
                  </div>

                  <div
                    className={
                      sidebarPositionDetails
                        ? "position-details-slider__active"
                        : "position-details-slider"
                    }
                  >
                    <div className="slider-container">
                      <div className="container-title-slider">
                        <p className="title-slider">SPECIFICATIONS</p>

                        <FontAwesomeIcon
                          className="close-icon"
                          icon={faXmark}
                          onClick={showSideBarPositionDetails}
                        />
                      </div>
                      {creatives[creativeNumber].adPositions[positionNumber]
                        .extraInformation && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html:
                              creatives[creativeNumber].adPositions[
                                positionNumber
                              ].extraInformation,
                          }}
                        />
                      )}

                      {creatives[creativeNumber].adPositions[
                        positionNumber
                      ]?.positionsList[positionListNumber].details?.map(
                        (detail) => {
                          const { title, infoFields } = detail;

                          return (
                            <div key={title}>
                              <ul className="specification-list">
                                <li className="title-specifications">
                                  {title}
                                </li>

                                {infoFields?.map((infoField, index) => {
                                  const { subject, text, type, url } =
                                    infoField;
                                  return (
                                    <li key={index}>
                                      {displayFields(subject, text, type, url)}
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>

                  {creatives[creativeNumber].details[0] && (
                    <div className="generic-container">
                      <p className="position-title">Generic</p>
                      <SpecsheetButtonWhite
                        type="button"
                        handleClick={showSidebarGenericSpecsheetInformation}
                      >
                        Creative Information
                      </SpecsheetButtonWhite>

                      <div
                        className={
                          sidebarCreativeInformation
                            ? "creative-information-container__active"
                            : "creative-information-container"
                        }
                      >
                        <div className="slider-container">
                          <div className="container-title-slider">
                            <p className="title-slider">CREATIVE INFORMATION</p>

                            <FontAwesomeIcon
                              className="close-icon"
                              icon={faXmark}
                              onClick={showSidebarGenericSpecsheetInformation}
                            />
                          </div>
                          {creatives[creativeNumber].details.map((detail) => {
                            const { title, infoFields } = detail;

                            return (
                              <div key={title}>
                                <ul className="specification-list">
                                  <li className="title-specifications">
                                    {title}
                                  </li>

                                  {infoFields?.map((infoField, index) => {
                                    const { subject, text, type, url } =
                                      infoField;
                                    return (
                                      <li key={index}>
                                        {displayFields(
                                          subject,
                                          text,
                                          type,
                                          url
                                        )}
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    <p className="position-title">Preview page</p>
                    {previewPages.map((page, index) => {
                      return (
                        <div
                          key={index}
                          className="preview-pages-list-container"
                        >
                          {page.title !== "" && (
                            <div className="preview-pages-list-title">
                              {page.title}:{" "}
                            </div>
                          )}
                          <section className="preview-pages-list-pages">
                            {page.websites.map((item, index, arr) => {
                              const result = [];
                              if (arr.length - 1 === index) {
                                result.push(
                                  <span key={index}>{item.site} </span>
                                );
                              } else {
                                result.push(
                                  <span key={index}>{item.site}, </span>
                                );
                              }
                              return result;
                            })}
                          </section>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          )}
          {displayImageContainer(creatives[creativeNumber].images)}
        </div>
      </div>
      <div
        className={overlayActive ? "overlay-visible" : "overlay"}
        onClick={resetOverlay}
      ></div>
    </div>
  );
};

export default Sheet;
